import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "meta-modal__header" }
const _hoisted_2 = { class: "meta-modal__heading" }
const _hoisted_3 = {
  key: 1,
  class: "meta-modal__body-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    class: "meta-modal__container",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event)),
    "no-backdrop-dismiss": "",
    "no-esc-dismiss": ""
  }, {
    default: _withCtx(() => [
      (!_ctx.views)
        ? _renderSlot(_ctx.$slots, "placeholder", { key: 0 }, () => [
            _createVNode(_component_q_card, { class: "meta-modal__placeholder" }, {
              default: _withCtx(() => [
                _createVNode(_component_spinner, {
                  scale: 0.5,
                  visible: true,
                  style: {"margin":"0 auto","width":"50px"}
                })
              ]),
              _: 1
            })
          ], true)
        : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
            _createVNode(_component_q_card, { class: "meta-modal" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, index) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    (_ctx.active?.id === view?.id)
                      ? _renderSlot(_ctx.$slots, "header", { key: 0 }, () => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", {
                              class: "meta-modal__arrow t-icon",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args))),
                              style: _normalizeStyle({opacity: (_ctx.activeIndex <= 0 || _ctx.disablePrevious) ? 0 : 1, pointerEvents: (_ctx.activeIndex <= 0 || _ctx.disablePrevious) ? 'none' : 'all'})
                            }, "a", 4),
                            _createElementVNode("div", _hoisted_2, _toDisplayString(view.label), 1),
                            _createElementVNode("div", {
                              class: "meta-modal__cancel t-icon",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                            }, "j")
                          ])
                        ], true)
                      : _createCommentVNode("", true),
                    (_ctx.active?.id === view?.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_ctx.active && _ctx.active?.id === view?.id)
                            ? _renderSlot(_ctx.$slots, view.id, {
                                key: 0,
                                index: index,
                                view: view,
                                active: _ctx.active,
                                switchTab: _ctx.switchTab,
                                views: _ctx.views,
                                setPrevious: _ctx.setPrevious
                              }, undefined, true)
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ]),
              _: 3
            })
          ], true)
    ]),
    _: 3
  }, 8, ["modelValue"]))
}